import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=2b05bb9c&scoped=true&"
import script from "./Gifts.vue?vue&type=script&lang=js&"
export * from "./Gifts.vue?vue&type=script&lang=js&"
import style0 from "./Gifts.vue?vue&type=style&index=0&id=2b05bb9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05bb9c",
  null
  
)

export default component.exports